<template>
<div>
    <br/>
    <title-minor>
        &lt;{{ name }}<tpl :content="inlineAttrs"></tpl>>
        {{ slotDescr }}
        &lt;/{{ name }}>
    </title-minor>
</div>
</template>
<script>
export default {
    props: {
        component: {
            type: Object,
            required: true,
        },
        slotDescr: {
            type: String,
        },
        name: {
            type: String,
        },
    },
    computed: {
        attrs () {
            let makeAttrs = props => props ? Object.keys(props).map(key => (
                {
                    name: key,
                    descr: props[key]._descr,
                    required: !!props[key].required,
                }
            )).filter(props => props.descr) : []

            let attrs = makeAttrs(this.component.props)

            if (this.component.mixins) {
                this.component.mixins.forEach(mixin => {
                    attrs = attrs.concat(makeAttrs(mixin.props))
                })
            }

            return attrs
        },
        inlineAttrs () {
            return this.attrs.map(attr => {
                let inline = `${attr.name}${attr.descr ? `: ${attr.descr}` : ''}`
                return (attr.required ? ' ' + inline : ` [${inline}]`)
            }).join('</br>')
        },
    },
    components: {
        'title-minor': require('./title-minor.vue').default,
        tpl: require('./tpl.vue').default,
    },
}
</script>
